export function isContactActive(active: string): boolean {
  return ['true', '1', 'active'].includes(String(active).toLowerCase());
}
